import SystemSetting from '@/modules/system-setting/router';
import VoteManage from '@/modules/voting-manage/router';
import InspirationCenter from '@/modules/inspiration-center/router';
import DigitalPrint from '@/modules/digital-print/router';
import SelectionManage from '@/modules/selection-manage/router';

import MaterialLibrary from '@/modules/material-library/router';
import BaseConfig from '@/modules/base-config/router';

// 外部页面
import ExternalSystems from '@/modules/external-systems/router';

export default [
  ...SystemSetting,
  ...VoteManage,
  ...InspirationCenter,
  ...DigitalPrint,
  ...SelectionManage,
  ...MaterialLibrary,
  ...ExternalSystems,
  ...BaseConfig
];
